import { render, staticRenderFns } from "./UnavailablePageModal.vue?vue&type=template&id=2b561b15"
import script from "./UnavailablePageModal.vue?vue&type=script&lang=js"
export * from "./UnavailablePageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports